import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BEManufacturingCoursePage: React.FC = () => {
  const courseData = {
    title: "B.E. Manufacturing Engineering",
    shortName: "B.E. Manufacturing",
    duration: "4 years",
    description: "Engineering program focused on optimizing manufacturing processes, production systems, and industrial operations",
    overview: "Bachelor of Engineering in Manufacturing Engineering (B.E. Manufacturing) is a 4-year undergraduate program that combines mechanical engineering with industrial engineering to optimize manufacturing processes. This course covers production planning, quality control, automation, lean manufacturing, and modern manufacturing technologies to prepare students for leadership roles in industrial production.",
    eligibility: [
      "10+2 with Physics, Chemistry, Mathematics",
      "Minimum 75% marks in JEE Main (50% for SC/ST)",
      "Valid JEE Main/State CET scores",
      "Interest in production and manufacturing systems"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Mathematics-I & II",
          "Physics",
          "Chemistry",
          "Engineering Graphics",
          "Workshop Technology",
          "Manufacturing Processes"
        ]
      },
      {
        year: 2,
        subjects: [
          "Strength of Materials",
          "Thermodynamics",
          "Fluid Mechanics",
          "Materials Science",
          "Machine Tools",
          "Engineering Economics"
        ]
      },
      {
        year: 3,
        subjects: [
          "Production Planning and Control",
          "Quality Control and Assurance",
          "Industrial Automation",
          "CNC Programming",
          "Lean Manufacturing",
          "Supply Chain Management"
        ]
      },
      {
        year: 4,
        subjects: [
          "Advanced Manufacturing Systems",
          "Robotics in Manufacturing",
          "Six Sigma and TQM",
          "Plant Layout and Design",
          "Project Work",
          "Industrial Training"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Manufacturing Engineer",
        "Production Manager",
        "Quality Control Engineer",
        "Process Engineer",
        "Plant Manager",
        "Industrial Engineer",
        "Operations Manager",
        "Manufacturing Consultant"
      ],
      industries: [
        "Automotive Manufacturing",
        "Electronics Manufacturing",
        "Pharmaceutical Production",
        "Textile Industry",
        "Food Processing",
        "Steel and Metal Industries",
        "Aerospace Manufacturing",
        "Consumer Goods"
      ],
      averageSalary: "₹4-8 LPA (Fresher), ₹12-28 LPA (Experienced)",
      topRecruiters: [
        "Tata Motors, Mahindra",
        "Bosch, Continental",
        "L&T, Godrej",
        "ITC, Hindustan Unilever",
        "Bajaj Auto, Hero MotoCorp",
        "Maruti Suzuki, Hyundai"
      ]
    },

    admissionProcess: [
      "TNEA Counselling (for Tamil Nadu colleges)",
      "JEE Main (for NITs and central universities)",
      "State-level entrance exams",
      "Management quota admissions",
      "Direct admission based on 12th marks"
    ],

    topColleges: [
      {
        name: "College of Engineering Guindy, Anna University",
        location: "Chennai",
        fees: "₹2,00,000",
        ranking: "NIRF Ranking: 35"
      },
      {
        name: "PSG College of Technology",
        location: "Coimbatore",
        fees: "₹4,50,000",
        ranking: "NIRF Ranking: 42"
      },
      {
        name: "Kumaraguru College of Technology",
        location: "Coimbatore",
        fees: "₹4,00,000",
        ranking: "NAAC A+ Grade"
      },
      {
        name: "Thiagarajar College of Engineering",
        location: "Madurai",
        fees: "₹3,20,000",
        ranking: "NIRF Ranking: 78"
      }
    ],

    skills: [
      "Production Planning",
      "Quality Management Systems",
      "Lean Manufacturing",
      "Six Sigma Methodologies",
      "CAD/CAM Software",
      "Industrial Automation",
      "Supply Chain Management",
      "Project Management",
      "Data Analysis",
      "Leadership and Communication"
    ],

    futureScope: "Excellent opportunities with Industry 4.0, smart manufacturing, automation technologies, and India's focus on 'Make in India' initiative driving manufacturing growth.",

    faqs: [
      {
        question: "What is the difference between Manufacturing and Mechanical Engineering?",
        answer: "Manufacturing Engineering focuses specifically on production processes, quality control, and industrial operations, while Mechanical Engineering covers broader mechanical systems design."
      },
      {
        question: "Are there opportunities in startups?",
        answer: "Yes, many manufacturing startups need engineers for setting up production lines, quality systems, and scaling operations efficiently."
      },
      {
        question: "Can I work in service industries?",
        answer: "Yes, manufacturing engineering principles apply to service operations, logistics, consulting, and process improvement across various sectors."
      },
      {
        question: "What are the higher study options?",
        answer: "M.E./M.Tech in Manufacturing/Industrial Engineering, MBA in Operations, or specialized certifications in Lean Six Sigma and quality management."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {courseData.title}
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BEManufacturingCoursePage;
